import tablelistApi from 'api/tablelistApi'

export default {
  me() {
    return tablelistApi.get('/user/me', null)
  },
  updateMe(data) {
    if (!data) throw new Error('data is required')

    return tablelistApi.put('/user/me', data)
  },
}



// WEBPACK FOOTER //
// ./src/api/user/service.js